const projectsData = [
  {
    id: 1,
    img: "https://i.ibb.co/MMKkzd3/creative.png",
    title: "Creative-Agency (MERN Project)",
    description:
      "A fullstack Agency app using ReactJS, MongoDB, ExpressJS and NodeJS",
    github: "https://github.com/azizul016/creative-agency-client",
    liveServer: "https://creative-agency-13e91.web.app/",
  },
  {
    id: 2,
    img:
      "https://i.ibb.co/qspdxs2/screenshot-memory-project-e0f5c-web-app-2021-03-08-18-49-33.png",
    title: "Memory-Project (MERN Project)",
    description:
      "A fullstack Memory app project using ReactJS, Mongoose, Redux and NodeJS",
    github: "https://github.com/azizul016/memory-project-client",
    liveServer: "https://memory-project-e0f5c.web.app/",
  },

  {
    id: 3,
    img: "https://i.ibb.co/54TMqWJ/voluntear.png",
    title: "Volunteer-Network (MERN Project)",
    description: "A fullstack Agency app using ReactJS, MongoDB and NodeJS",
    github: "https://github.com/azizul016/volunteer-network-client",
    liveServer: "https://volunteer-network-32957.web.app/",
  },
  {
    id: 4,
    img: "https://i.ibb.co/Zgh7JmB/Web1.png",
    title: "Athena-App",
    description:
      "Athena app is a design based app that made by ReactJS, SCSS and react bootstrap",
    github: "https://github.com/azizul016/athena-design",
    liveServer: "https://athena-app.netlify.app/",
  },
  {
    id: 5,
    img:
      "https://i.ibb.co/JBr90Vk/screenshot-apartment-hunt-main-web-app-2021-03-08-19-18-27.png",
    title: "Appartment Hunt (MERN Project)",
    description:
      "A fullstack Agency app using ReactJS, MongoDB,Mongoose and NodeJS",
    github: "https://github.com/azizul016/appartment-hunt-client-site",
    liveServer: "https://apartment-hunt-main.web.app/",
  },
  {
    id: 6,
    img: "https://i.ibb.co/fMZP8G7/Booking.png",
    title: "Travel-Guru",
    description:
      "Travel Guru web application made by React.js, Bootstrap, React-Router",
    github: "https://github.com/azizul016/travel-assinment",
    liveServer: "https://sad-heisenberg-39333f.netlify.app/",
  },
  {
    id: 6,
    img:
      "https://i.ibb.co/yYSpMvZ/screenshot-azizul016-github-io-2021-03-08-19-15-45.png",
    title: "Axit-web-Application",
    description: "Using React.js, Bootstrap, React-Router",
    github: "https://github.com/azizul016/axit-web-application",
    liveServer: "https://azizul016.github.io/axit-web-application/",
  },
  {
    id: 7,
    img: "https://i.ibb.co/gJF82c3/Screenshot-4.png",
    title: "E-School",
    description:
      "E-School application using HTML, CSS, BOOTSTRAP for simple design",
    github: "https://github.com/azizul016/e-school",
    liveServer: "https://azizul016.github.io/e-school/",
  },
  {
    id: 8,
    img: "https://i.ibb.co/xS9C3XB/Screenshot-1.png",
    title: "Fake Name Generator",
    description: "Using Random API",
    github: "https://github.com/azizul016/fake-profile-generator",
    liveServer: "https://azizul016.github.io/fake-profile-generator/",
  },
];

const totalBlog = [
  {
    id: 1,
    img: "https://i.ibb.co/qgnGdyH/react-JS.jpg",
    title: "Some important topics of ReactJs",
    blogLink:
      "https://azizul-haque.medium.com/some-important-topics-of-react-8be69228db90",
  },
  {
    id: 2,
    img: "https://i.ibb.co/zQt63HF/1-azep9-Fc-Snees-QNojs1001g.png",
    title: "Javascript Ten Tips",
    blogLink:
      "https://azizul-haque.medium.com/concact-vs-spread-operator-74b39f71cad9",
  },
  {
    id: 3,
    img: "https://i.ibb.co/QYZqB8c/basic.jpg",
    title: "Javascript Basic Concept",
    blogLink:
      "https://azizul-haque.medium.com/01-truthy-and-falsy-values-ed4ff6fd5e59",
  },
  {
    id: 4,
    img: "https://i.ibb.co/9s9fMsz/include.png",
    title: "Includes Method for String and Array",
    blogLink:
      "https://azizul-haque.medium.com/includes-method-for-string-and-array-777d6b429dca",
  },

  {
    id: 5,
    img: "https://i.ibb.co/cgYCvts/photo-1579468118864-1b9ea3c0db4a.jpg",
    title: "Javascript another Ten Tips",
    blogLink:
      "https://azizul-haque.medium.com/javascript-another--trips-203940a5f21a",
  },
];

module.exports = {
  projectsData,
  totalBlog,
};
